/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Запрос на создание платежа по заявке из карточки заявки
 */
export type PaymentTransactionCreateFromOrderRequest = {
  /**
   * Метод оплаты (Card - банковской картой, Sbp - по QR-коду СБП)
   */
  method: PaymentTransactionCreateFromOrderRequest.Method
  /**
   * Email
   */
  email: string
}
export namespace PaymentTransactionCreateFromOrderRequest {
  /**
   * Метод оплаты (Card - банковской картой, Sbp - по QR-коду СБП)
   */
  export enum Method {
    CARD = 'card',
    SBP = 'sbp'
  }
}
